import { cmsHttp } from 'shared/api/mfe-axios';
import { REQUEST, SUCCESS, FAILURE } from 'shared/lib/reducers/action-type.util';
export const ACTION_TYPES = {
    FETCH_CARD_LIMITS_BY_PRODUCT: 'cardLimit/FETCH_CARD_LIMITS_BY_PRODUCT',
    FETCH_CARD_LIMITS_BY_CARD: 'cardLimit/FETCH_CARD_LIMITS_BY_CARD',
    CREATE_CARD_LIMIT: 'cardLimit/CREATE_CARD_LIMIT',
    UPDATE_CARD_LIMIT: 'cardLimit/UPDATE_CARD_LIMIT',
    DELETE_CARD_LIMIT: 'cardLimit/DELETE_CARD_LIMIT',
    RESET: 'cardLimit/RESET',
};
const apiUrl = 'api/card-limits';
const initialState = {
    loading: false,
    errorMessage: null,
    entities: [],
    updating: false,
    updateSuccess: false,
};
const toLimitList = (body) => {
    if (Array.isArray(body)) {
        return body;
    }
    if (body != null && typeof body === 'object') {
        const content = body.content;
        if (Array.isArray(content)) {
            return content;
        }
        return [body];
    }
    return [];
};
export default (state = initialState, action) => {
    switch (action.type) {
        case REQUEST(ACTION_TYPES.FETCH_CARD_LIMITS_BY_PRODUCT):
        case REQUEST(ACTION_TYPES.FETCH_CARD_LIMITS_BY_CARD):
            return {
                ...state,
                errorMessage: null,
                updateSuccess: false,
                loading: true,
            };
        case REQUEST(ACTION_TYPES.CREATE_CARD_LIMIT):
        case REQUEST(ACTION_TYPES.UPDATE_CARD_LIMIT):
        case REQUEST(ACTION_TYPES.DELETE_CARD_LIMIT):
            return {
                ...state,
                errorMessage: null,
                updateSuccess: false,
                updating: true,
            };
        case FAILURE(ACTION_TYPES.FETCH_CARD_LIMITS_BY_PRODUCT):
        case FAILURE(ACTION_TYPES.FETCH_CARD_LIMITS_BY_CARD):
        case FAILURE(ACTION_TYPES.CREATE_CARD_LIMIT):
        case FAILURE(ACTION_TYPES.UPDATE_CARD_LIMIT):
        case FAILURE(ACTION_TYPES.DELETE_CARD_LIMIT):
            return {
                ...state,
                loading: false,
                updating: false,
                updateSuccess: false,
                errorMessage: action.payload,
            };
        case SUCCESS(ACTION_TYPES.FETCH_CARD_LIMITS_BY_PRODUCT):
        case SUCCESS(ACTION_TYPES.FETCH_CARD_LIMITS_BY_CARD): {
            const body = action.payload.data;
            const list = toLimitList(body);
            return {
                ...state,
                loading: false,
                entities: list,
            };
        }
        case SUCCESS(ACTION_TYPES.CREATE_CARD_LIMIT):
        case SUCCESS(ACTION_TYPES.UPDATE_CARD_LIMIT):
        case SUCCESS(ACTION_TYPES.DELETE_CARD_LIMIT):
            return {
                ...state,
                updating: false,
                updateSuccess: true,
                loading: false,
            };
        case ACTION_TYPES.RESET:
            return {
                ...initialState,
            };
        default:
            return state;
    }
};
const toApiDateField = (value) => {
    if (value == null) {
        return value;
    }
    return value instanceof Date ? value.toISOString() : value;
};
const toApiPayload = (entity, options) => {
    const includeId = options?.includeId ?? false;
    const { id, windowConfigJson: _windowConfigJson, ...rest } = entity;
    const payload = {
        ...rest,
        effectiveFrom: toApiDateField(entity.effectiveFrom),
        effectiveUntil: toApiDateField(entity.effectiveUntil),
    };
    if (includeId && id != null) {
        return { ...payload, id };
    }
    return payload;
};
const buildLimitsQuery = (filters) => {
    if (!filters) {
        return '';
    }
    const parts = [];
    const q = (key, value) => {
        if (value === undefined || value === null) {
            return;
        }
        if (typeof value === 'string' && value.trim() === '') {
            return;
        }
        parts.push(`${key}=${encodeURIComponent(String(value))}`);
    };
    q('limitScope.equals', filters.limitScope);
    q('windowType.equals', filters.windowType);
    if (filters.amountLimitEquals != null) {
        q('amountLimit.equals', filters.amountLimitEquals);
    }
    if (filters.amountLimitGte != null) {
        q('amountLimit.greaterThanOrEqual', filters.amountLimitGte);
    }
    if (filters.amountLimitLte != null) {
        q('amountLimit.lessThanOrEqual', filters.amountLimitLte);
    }
    if (filters.countLimitEquals != null) {
        q('countLimit.equals', filters.countLimitEquals);
    }
    if (filters.countLimitGte != null) {
        q('countLimit.greaterThanOrEqual', filters.countLimitGte);
    }
    if (filters.countLimitLte != null) {
        q('countLimit.lessThanOrEqual', filters.countLimitLte);
    }
    if (filters.currencyCodeContains?.trim()) {
        q('currencyCode.contains', filters.currencyCodeContains.trim());
    }
    if (filters.isOverride === true || filters.isOverride === false) {
        q('isOverride.equals', filters.isOverride);
    }
    q('status.equals', filters.status);
    q('appliesToChannel.equals', filters.appliesToChannel);
    q('appliesToCountry.equals', filters.appliesToCountry);
    q('effectiveFrom.greaterThanOrEqual', filters.effectiveFromGte);
    q('effectiveFrom.lessThanOrEqual', filters.effectiveFromLte);
    q('effectiveUntil.greaterThanOrEqual', filters.effectiveUntilGte);
    q('effectiveUntil.lessThanOrEqual', filters.effectiveUntilLte);
    return parts.length ? `?${parts.join('&')}` : '';
};
export const getLimitsByProductId = (productId, filters) => ({
    type: ACTION_TYPES.FETCH_CARD_LIMITS_BY_PRODUCT,
    payload: cmsHttp().get(`${apiUrl}/product/${productId}${buildLimitsQuery(filters)}`),
});
export const getLimitsByCardId = (cardId, filters) => ({
    type: ACTION_TYPES.FETCH_CARD_LIMITS_BY_CARD,
    payload: cmsHttp().get(`${apiUrl}/card/${cardId}${buildLimitsQuery(filters)}`),
});
export const createEntity = (entity) => async (dispatch) => {
    const body = toApiPayload(entity);
    return dispatch({
        type: ACTION_TYPES.CREATE_CARD_LIMIT,
        payload: cmsHttp().post(apiUrl, body),
    });
};
export const updateEntity = (entity) => async (dispatch) => {
    if (entity.id == null) {
        return undefined;
    }
    return dispatch({
        type: ACTION_TYPES.UPDATE_CARD_LIMIT,
        payload: cmsHttp().patch(`${apiUrl}/${entity.id}`, toApiPayload(entity, { includeId: true })),
    });
};
export const deleteEntity = (id) => async (dispatch) => dispatch({
    type: ACTION_TYPES.DELETE_CARD_LIMIT,
    payload: cmsHttp().delete(`${apiUrl}/${id}`),
});
export const reset = () => ({
    type: ACTION_TYPES.RESET,
});
